module.exports = __webpack_public_path__ + "media/images/strategic-partners/new/Medmo-a85d2cb03a126ff446ee3f66ba55aa43.png";